/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ContainsIdDTO } from "./ContainsIdDTO";
import { ContainsIdDTOFromJSON, ContainsIdDTOFromJSONTyped, ContainsIdDTOToJSON } from "./ContainsIdDTO";
import type { InImageDTO } from "./InImageDTO";
import { InImageDTOFromJSON, InImageDTOFromJSONTyped, InImageDTOToJSON } from "./InImageDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";

/**
 *
 * @export
 * @interface InDealDTO
 */
export interface InDealDTO {
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  id: number;
  /**
   * Exactly one EAN, no "|" list
   * @type {string}
   * @memberof InDealDTO
   */
  ean?: string;
  /**
   *
   * @type {string}
   * @memberof InDealDTO
   */
  sku?: string;
  /**
   *
   * @type {string}
   * @memberof InDealDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof InDealDTO
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InDealDTO
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof InDealDTO
   */
  usp?: string;
  /**
   *
   * @type {boolean}
   * @memberof InDealDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof InDealDTO
   */
  currency?: string;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  stock?: number;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  scoreModifier?: number;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  score?: number;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  beforePrice?: number;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  discount?: number;
  /**
   *
   * @type {number}
   * @memberof InDealDTO
   */
  sponsoredPosition?: number;
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof InDealDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {Date}
   * @memberof InDealDTO
   */
  lastSyncMoment?: Date;
  /**
   *
   * @type {Date}
   * @memberof InDealDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof InDealDTO
   */
  updatedAtByUser?: Date;
  /**
   *
   * @type {InImageDTO}
   * @memberof InDealDTO
   */
  image?: InImageDTO;
  /**
   *
   * @type {ContainsIdDTO}
   * @memberof InDealDTO
   */
  merchant?: ContainsIdDTO;
  /**
   *
   * @type {Array<ContainsIdDTO>}
   * @memberof InDealDTO
   */
  brands?: Array<ContainsIdDTO>;
  /**
   *
   * @type {Array<ContainsIdDTO>}
   * @memberof InDealDTO
   */
  categories?: Array<ContainsIdDTO>;
  /**
   *
   * @type {ContainsIdDTO}
   * @memberof InDealDTO
   */
  featuredFilter?: ContainsIdDTO;
  /**
   *
   * @type {Array<ContainsIdDTO>}
   * @memberof InDealDTO
   */
  externalDealFilters?: Array<ContainsIdDTO>;
}

/**
 * Check if a given object implements the InDealDTO interface.
 */
export function instanceOfInDealDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "platform" in value;

  return isInstance;
}

export function InDealDTOFromJSON(json: any): InDealDTO {
  return InDealDTOFromJSONTyped(json, false);
}

export function InDealDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InDealDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    sku: !exists(json, "sku") ? undefined : json["sku"],
    name: json["name"],
    slug: !exists(json, "slug") ? undefined : json["slug"],
    url: !exists(json, "url") ? undefined : json["url"],
    usp: !exists(json, "usp") ? undefined : json["usp"],
    live: json["live"],
    currency: !exists(json, "currency") ? undefined : json["currency"],
    stock: !exists(json, "stock") ? undefined : json["stock"],
    scoreModifier: !exists(json, "scoreModifier") ? undefined : json["scoreModifier"],
    score: !exists(json, "score") ? undefined : json["score"],
    price: !exists(json, "price") ? undefined : json["price"],
    beforePrice: !exists(json, "beforePrice") ? undefined : json["beforePrice"],
    discount: !exists(json, "discount") ? undefined : json["discount"],
    sponsoredPosition: !exists(json, "sponsoredPosition") ? undefined : json["sponsoredPosition"],
    platform: PlatformRefDTOFromJSON(json["platform"]),
    lastSyncMoment: !exists(json, "lastSyncMoment") ? undefined : new Date(json["lastSyncMoment"]),
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    updatedAtByUser: !exists(json, "updatedAtByUser") ? undefined : new Date(json["updatedAtByUser"]),
    image: !exists(json, "image") ? undefined : InImageDTOFromJSON(json["image"]),
    merchant: !exists(json, "merchant") ? undefined : ContainsIdDTOFromJSON(json["merchant"]),
    brands: !exists(json, "brands") ? undefined : (json["brands"] as Array<any>).map(ContainsIdDTOFromJSON),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(ContainsIdDTOFromJSON),
    featuredFilter: !exists(json, "featuredFilter") ? undefined : ContainsIdDTOFromJSON(json["featuredFilter"]),
    externalDealFilters: !exists(json, "externalDealFilters")
      ? undefined
      : (json["externalDealFilters"] as Array<any>).map(ContainsIdDTOFromJSON)
  };
}

export function InDealDTOToJSON(value?: InDealDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    ean: value.ean,
    sku: value.sku,
    name: value.name,
    slug: value.slug,
    url: value.url,
    usp: value.usp,
    live: value.live,
    currency: value.currency,
    stock: value.stock,
    scoreModifier: value.scoreModifier,
    score: value.score,
    price: value.price,
    beforePrice: value.beforePrice,
    discount: value.discount,
    sponsoredPosition: value.sponsoredPosition,
    platform: PlatformRefDTOToJSON(value.platform),
    lastSyncMoment: value.lastSyncMoment === undefined ? undefined : value.lastSyncMoment.toISOString(),
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    updatedAtByUser: value.updatedAtByUser === undefined ? undefined : value.updatedAtByUser.toISOString(),
    image: InImageDTOToJSON(value.image),
    merchant: ContainsIdDTOToJSON(value.merchant),
    brands: value.brands === undefined ? undefined : (value.brands as Array<any>).map(ContainsIdDTOToJSON),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(ContainsIdDTOToJSON),
    featuredFilter: ContainsIdDTOToJSON(value.featuredFilter),
    externalDealFilters:
      value.externalDealFilters === undefined
        ? undefined
        : (value.externalDealFilters as Array<any>).map(ContainsIdDTOToJSON)
  };
}
